export const BOTTOM_LINE_NAME = 'bottom-line';
